import React from 'react';
import { IBlogCategory } from "components/base/RelatedCard";
import useTrans from "components/hooks/useTrans";

type Props = {
    categories: IBlogCategory[];
    className?: string;
    readTime: number;
};

export default function MetaData(props: Props) {
    const { categories, className, readTime } = props;
    const { t } = useTrans();

    return (
        <div className={'flex'}>
                    <p className={'text-gray-500 font-medium'} key={categories[0].name}>
                        {categories[0].name}
                        &nbsp;·&nbsp;
                    </p>

            {/*{categories.map((category) => {*/}
            {/*    return category.name &&  (*/}
            {/*        <p className={'font-normal'} key={category.name}>*/}
            {/*            {category.name}*/}
            {/*            &nbsp;·&nbsp;*/}
            {/*        </p>*/}
            {/*    );*/}
            {/*})}*/}
            <p className={'text-gray-500 font-light'}>
                {readTime} {t('minutes')}
            </p>
        </div>
    );
}